import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";
import CustomCategoryWeightRangeSalePrice from "../../../model/packageDelivery/customCategory/CustomCategoryWeightRangeSalePrice";

class NewPackageCustomCategoryWeightRangeSalePriceStore {

    public salePriceId: string;
    public customCategoryId: string;
    public salePriceCustomCategoryWeightRange: CustomCategoryWeightRangeSalePrice;
    public isEditing: boolean;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    public changeError?: string;

    constructor(
        commonStore: CommonStore,
        salePriceId: string,
        customCategoryId: string,
        salePriceCustomCategoryWeightRange?: CustomCategoryWeightRangeSalePrice,
    ) {
        this.salePriceId = salePriceId;
        this.customCategoryId = customCategoryId;
        this.isEditing = !!salePriceCustomCategoryWeightRange;
        this.salePriceCustomCategoryWeightRange = salePriceCustomCategoryWeightRange ?? {} as CustomCategoryWeightRangeSalePrice;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        let response;

        if (this.isEditing) {
            response = await SalePriceService.updateCustomCategoryWeightRangeItemSalePrice(
                this.salePriceId,
                this.salePriceCustomCategoryWeightRange.id!,
                this.salePriceCustomCategoryWeightRange
            );
        } else {
            response = await SalePriceService.createCustomCategoryWeightRangeItemSalePrice(
                this.salePriceId,
                this.customCategoryId,
                this.salePriceCustomCategoryWeightRange,
            );
        }

        this.commonStore.processErrors(response);
        this.loading = false;
        return response.success;
    }

}

export default NewPackageCustomCategoryWeightRangeSalePriceStore;